import State from '../core/State';

const setDrawerOpen = (open: boolean) => (state: State): State => ({
  ...state,
  drawerOpen: open,
});

export default setDrawerOpen;
